export const colors = {
  primary: {
    main: '#ff68b4',
    light: '#fff0f5',
    lighter: '#ffe4e1',
    disabled: '#cccccc',
  },
  blue: {
    main: '#0095f6',
    dark: '#0077c2',
    light: '#7cc5d9',
    verified: '#3897f0',
  },
  text: {
    primary: '#262626',
    secondary: '#8e8e8e',
    light: '#ffffff',
    gray: '#666',
  },
  background: {
    main: '#ffffff',
    backend: '#FFF6FB',
  },
  border: {
    main: '#dbdbdb',
  },
  gray: {
    main: '#4a4a4a',
  },
};
